import classNames from 'clsx';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { remove, selectOne } from 'reactApp/modules/selections/selections.actions';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { AlbumLabel } from 'reactApp/ui/AlbumLabel/AlbumLabel';
import { renderContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { MoreHorizontalIcon } from 'reactApp/ui/VKUIIcons';

import styles from './Album.css';

const CONTEXT_MENU_OFFSET = 8;

export const Options = memo(function Options({ id, storage }: { id: string; storage: EStorageType }) {
    const [isShow, setShow] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();

    const handleOnClick = useCallback((event) => {
        if (!ref.current) {
            return;
        }

        event.persist();
        event.preventDefault();

        event.nativeEvent._albumOptionsClickedId = id;

        setShow(true);
        dispatch(selectOne({ selectedIdx: id, storage }));

        const { left, bottom } = ref.current.getBoundingClientRect();

        renderContextMenu({
            posX: left + window.scrollX,
            posY: bottom + window.scrollY + CONTEXT_MENU_OFFSET,
            gaSuffix: 'albums',
        });
    }, []);

    const onDocumentClick = (event) => {
        if (event._albumOptionsClickedId && event._albumOptionsClickedId === id) {
            return;
        }

        dispatch(remove({ selectedIdx: id }));
        setShow(false);
    };

    useEffect(() => {
        if (!isShow) {
            return;
        }

        document.addEventListener('click', onDocumentClick);
        return () => document.removeEventListener('click', onDocumentClick);
    }, [isShow]);

    return (
        <AlbumLabel
            className={classNames(styles.options, { [styles.options_visible]: isShow })}
            ref={ref}
            onClick={handleOnClick}
            qaLabel="options"
        >
            <MoreHorizontalIcon />
        </AlbumLabel>
    );
});
